import { POSITION_MNG } from '@/api/apiModules'
export default {
  viewType: 'form',
  module: POSITION_MNG,
  needFetchFillInfo: true,
  params: null,
  toolbar: {},
  extraParams: null,
  formatData(data) {
    return data
  },
  view: {
    title: '添加岗位信息',
    labelPosition: 'right',
    labelWidth: '165px',
    width: '550px',
    content: [
      {
        $id: 'positionName',
        $type: 'input',
        label: '岗位名称',
        rules: [
          {
            notEmpty: '岗位名称'
          }
        ]
      },
      {
        $id: 'positionDesc',
        $type: 'input',
        label: '岗位描述'
      },
      {
        $id: 'positionDesktop',
        $type: 'sky-position-desktop-relate',
        label: '默认桌面配置'
      },
      {
        $id: 'positionPeripheralList',
        $type: 'sky-position-peripheral-relate',
        label: '默认外设'
      },
      {
        $id: 'positionSoftwareList',
        $type: 'sky-position-software-relate',
        label: '默认软件'
      }
    ]
  }
}
